import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import { newStoreFunction, getFunctionDetail, editFunction } from './request.js';
export default {
  data() {
    return {
      form: {},
      loading: false,
      inputTypeOption: [{
        label: '文本',
        value: 'TEXT'
      }, {
        label: '数字',
        value: 'NUMBER'
      }, {
        label: '日期',
        value: 'DATE'
      }, {
        label: '时间',
        value: 'TIME'
      }, {
        label: '函数',
        value: 'FUNCTION'
      }],
      outputTypeOption: [{
        label: '文本',
        value: 'TEXT'
      }, {
        label: '数字',
        value: 'NUMBER'
      }, {
        label: '日期',
        value: 'DATE'
      }, {
        label: '时间',
        value: 'TIME'
      }, {
        label: '函数',
        value: 'FUNCTION'
      }, {
        label: '列表',
        value: 'LIST'
      }]
    };
  },
  computed: {
    ruleData() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('函数名称'),
          trigger: 'blur'
        }],
        mark: [{
          required: true,
          message: this.$t('请输入') + this.$t('函数标识'),
          trigger: 'blur'
        }],
        tipDescription: [{
          required: true,
          message: this.$t('请输入') + this.$t('提示说明'),
          trigger: 'blur'
        }],
        example: [{
          required: true,
          message: this.$t('请输入') + this.$t('函数示例'),
          trigger: 'blur'
        }],
        inputType: [{
          required: true,
          message: this.$t('请选择') + this.$t('输入类型'),
          trigger: 'change'
        }],
        inputNumber: [{
          required: true,
          validator: this.validateInputNumber,
          trigger: 'blur'
        }],
        outputType: [{
          required: true,
          message: this.$t('请选择') + this.$t('输出类型'),
          trigger: 'change'
        }]
      };
    }
  },
  created() {
    const id = this.$route.params.id;
    let type = this.$route.params.type;
    if (type === 'edit' || type === 'see') {
      //编辑字段
      this.$route.meta.title = type === 'edit' ? this.$t('编辑函数') : this.$t('查看函数');
      getFunctionDetail({
        id
      }).then(res => {
        this.form = {
          name: res.name,
          mark: res.mark,
          tipDescription: res.tipDescription,
          example: res.example,
          inputType: res.inputType.split(','),
          inputNumber: res.inputNumber,
          inputDescription: res.inputDescription,
          outputDescription: res.outputDescription,
          outputType: res.outputType,
          remark: res.remark
        };
      });
    } else {
      // 新增传递的id是-1
      this.$route.meta.title = '新增函数';
    }
  },
  methods: {
    validateInputNumber(rules, value, callback) {
      if (!value && value !== 0) {
        callback(new Error(this.$t('请输入') + this.$t('输入个数')));
      }
      if (value < 0 || value > 10) {
        callback(new Error(this.$t('输入范围0~10')));
      }
      callback();
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let params = {
            name: this.form.name,
            mark: this.form.mark,
            tipDescription: this.form.tipDescription,
            example: this.form.example,
            inputType: this.form.inputType.join(','),
            inputNumber: this.form.inputNumber,
            inputDescription: this.form.inputDescription,
            outputDescription: this.form.outputDescription,
            outputType: this.form.outputType,
            remark: this.form.remark
          };
          if (this.$route.params.id != -1) {
            params.id = this.$route.params.id;
            editFunction(params).then(res => {
              if (res && res.id) {
                this.$message.success(this.$t('编辑成功'));
                this.$router.push({
                  name: 'componentFunction'
                });
              }
            });
          } else {
            newStoreFunction(params).then(res => {
              if (res && res.id) {
                this.$message.success(this.$t('添加成功'));
                this.$refs.form.resetFields();
                this.$router.push({
                  name: 'componentFunction'
                });
              }
            });
          }
        }
      });
    }
  }
};